import api from './api';

const allForDevelopment = () =>
  api.basic({
    method: api.methods.get,
    url: '/users/all_for_development',
  });

const create = (params = {}) =>
  api.request({
    method: api.methods.post,
    url: '/signup',
    data: params,
  });

const show = (params = {}) =>
  api.request({
    method: api.methods.get,
    url: '/users/current',
    data: params,
  });

const updateAvatar = (avatarSeed = null) =>
  api.request({
    method: api.methods.patch,
    url: '/users/update_avatar',
    data: { avatar_seed: avatarSeed },
  });

const updatePassword = (params = {}) =>
  api.request({
    method: api.methods.patch,
    url: '/users/update_password',
    data: params,
  });

const updateProfile = (params = {}) =>
  api.request({
    method: api.methods.patch,
    url: '/users/update_profile',
    data: params,
  });

const resendConfirmationEmail = () =>
  api.request({
    method: api.methods.post,
    url: '/users/resend_confirmation_email',
  });

const confirmAccount = (params = { email: null, token: null }) =>
  api.request({
    method: api.methods.post,
    url: '/users/confirm_account',
    data: params,
  });

const userService = {
  allForDevelopment,
  create,
  show,
  current: show,
  updateAvatar,
  updatePassword,
  updateProfile,
  resendConfirmationEmail,
  confirmAccount,
};

export default userService;
